<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-form @submit="($event)=> $event.preventDefault()">
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Solicitante"
          label-for="input-1"
      >
        <p>{{ $localStorageService.getNombreCompletoUsuario() }}</p>
      </b-form-group>
      <b-form-group
          id="input-group-1"
          label-align="left"
          label="A favor / En Contra"
          label-for="input-1"
      >
        <v-select
            v-model="model.aFavor"
            :options="[{text: 'A favor', value: true}, {text: 'En contra', value: false}]"
            label="text"
            :reducer="(v)=>v.value"
            @input="forSelectTipoMovimiento"

        ></v-select>
      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Tipo"
          label-for="input-1"
      >
        <b-spinner small v-if="tipoMovimientoService.loading"/>
        <div v-else>
          <v-select
              v-model="model.tipoMovimiento"
              :options="tipoMovimientoService.data"
              label="text"
              :reducer="(v)=>v.value"
          ></v-select>
        </div>
      </b-form-group>
      <!-- Los tomamos del menu-->

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Clinica"
          label-for="input-1"
      >
        <v-select
            v-model="model.clinica"
            :options="clinicas"
            label="nombreClinica"
            @input="limpiarDatos"
            :reducer="(c)=> c.idClinica "
        ></v-select>

      </b-form-group>

      <b-form-group
          id="input-group-1"
          label-align="left"
          label="Paciente"
          label-for="input-1"
      >
        <b-input-group>
          <b-form-checkbox v-model="buscarPorId" >Buscar paciente por ID</b-form-checkbox>
        </b-input-group>
        <b-input-group>
          <b-form-input placeholder="Paciente (minimo 10 caracteres y 2 palabras)" v-model="nombre"/>
          <b-input-group-append>
            <b-button v-on:click="traerPacientesPorNombreLike">
              <b-spinner small variant="info" v-if="pacienteService.loading"/>
              <font-awesome-icon v-else icon="search"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <v-select
            v-model="model.paciente"
            :options="pacienteService.data"
            :reducer="(p)=> p.idPaciente"
            label="nombreCompleto"
            @input="traerSaldo"
        ></v-select>
        <div v-if="saldoBloqueado" style="font-weight: bold; color:red">
          Saldo congelado
        </div>
      </b-form-group>
      <b-form-group v-if="balance != null" class="text-left">
        <label class="text-left">Saldo actual del paciente emisor </label>
        <b-button variant="info" class="float-right" v-if="model.pacienteOrigen !== null"
                  v-on:click="traerSaldo(model.paciente)">
          <font-awesome-icon icon="sync"/>
        </b-button>
        <BalancePorTipoMovimiento v-if="balance!= null" :balance.sync="balance"/>
      </b-form-group>
      <b-form-group
          v-if="balance != null"
          id="input-group-1"
          label-align="left"
          label="Monto"
          label-for="input-1"
      >
        <b-form-input
            v-model="model.monto"
            type="text"
            @keypress="$onlyNumber"
            @keyup="$onlyNumber"
            @paste="$onlyNumber"
        />
      </b-form-group>

      <BotonYListaSubirArchivos v-if="model.paciente !== null" padre="Movimiento" :paciente="model.paciente.idPaciente" class="mb-2"
                                v-on:archivos="appendArchivo"></BotonYListaSubirArchivos>


      <b-button type="submit" :disabled="canSend" variant="primary" v-on:click="guardar" v-if="!saldoBloqueado">Guardar</b-button>

    </b-form>
  </div>
</template>

<script>
import {AreaService} from "@/apiServices/area/AreaService";
import {PacienteService} from "@/apiServices/paciente/PacienteService";
import _ from "lodash";
import {TipoMovimientoService} from "../../../apiServices/tipoMovimiento/TipoMovimientoService";
import {MovimientoCreateDto} from "../../../apiServices/dto/movimiento/MovimientoCreateDto";
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";
import BalancePorTipoMovimiento from "../catalogos/TipoMovimiento/BalancePorTipoMovimiento";
import BotonYListaSubirArchivos from "../../../components/archivos/BotonYListaSubirArchivos";

export default {
  name: "FormMovimiento",
  components: {BotonYListaSubirArchivos, BalancePorTipoMovimiento},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    clinicas: [],
    buscarPorId: false,
    nombre: '',
    balance: null,
    model: {
      tipoMovimiento: null,
      clinica: null,
      monto: null,
      paciente: null,
      empleado: null,
    },
    areaService: new AreaService(),
    pacienteService: new PacienteService(),
    tipoMovimientoService: new TipoMovimientoService(),
    movimientoService: new MovimientoService(),
    tiposMovimiento: [],
    archivos: [],
    saldoBloqueado: false
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.model.empleado = this.$localStorageService.getIdEmpleado();
    this.clinicas = _.orderBy(this.$localStorageService.getClinicas(), ['nombreClinica'], ['asc']);
    this.areaService.listar();
    this.$root.$on('refresh_tipo_movimiento', async () => {
      this.$root.$emit('bv::hide::modal-add_tipo_movimiento')
      this.tiposMovimiento = await this.tipoMovimientoService.forSelect(this.model.aFavor.value)
    });
  },
  methods: {
    guardar() {
      let toSave = new MovimientoCreateDto()
      toSave.monto = +this.model.monto;
      toSave.idPaciente = this.model.paciente.idPaciente;
      toSave.idEmpleadoSolicito = this.model.empleado;
      toSave.idClinica = this.model.clinica.idClinica;
      toSave.idTipoMovimiento = this.model.tipoMovimiento.value;
      toSave.archivos = this.archivos.map(e => e.idArchivo);
      this.movimientoService.crear(toSave).then(() => {
        this.model = {
          tipoMovimiento: null,
          clinica: null,
          monto: null,
          paciente: null,
          empleado: null,
        };
        this.balance = null;
        this.archivos = [];
        this.model.empleado = this.$localStorageService.getIdEmpleado();
        this.$root.$emit('archivos', []);
      })
    },
    appendArchivo(archivos) {
      this.archivos = archivos;
    },
    async forSelectTipoMovimiento() {
      this.tiposMovimiento = await this.tipoMovimientoService.forSelect(this.model.aFavor.value)
    },
    traerPacientesPorNombreLike() {
      this.pacienteService.data = [];
      if (this.buscarPorId === false && this.nombre.length > 9 && this.nombre.split(' ').length >= 2) {
        this.pacienteService.obtenerPacientesPorNombreLike(this.nombre.toUpperCase());
      }else if (this.buscarPorId === true){
        this.pacienteService.obtenerPacientesPorId(this.nombre.toUpperCase());
      }
    },
    async traerSaldo(paciente) {
      this.$root.$emit('paciente', paciente);
      this.model.paciente = paciente;
      this.balance = null;
      await this.verificarBloqueo();
      this.balance = await this.movimientoService.obtenerBalance({idPaciente: paciente.idPaciente});
    },
    limpiarDatos() {
      this.pacienteService.data = [];
      this.model.paciente = null;
      this.nombre = '';
    },
    verificarBloqueo(){
      this.saldoBloqueado = false;
      this.$http.post(this.$api + "ws/reembolsos/existeReembolsoProceso", {"idPaciente": this.model.paciente.idPaciente})
          .then((response) => {
            this.saldoBloqueado = response.data.success;
      });
    },
  },
  watch: {
    'model.monto'() {
      if (this.model.monto <= 0) {
        this.model.monto = '';
      }
    }
  },
  computed: {
    isLoading() {
      return this.areaService.loading || this.pacienteService.loading || this.tipoMovimientoService.loading || this.movimientoService.loading;
    },
    canSend() {
      return !(
          this.archivos.length > 0 &&
          this.model.monto > 0 &&
          this.model.paciente != null &&
          this.model.clinica != null &&
          this.model.empleado != null &&
          this.model.tipoMovimiento
      );
    }
  }
}
</script>

<style scoped>
</style>
